var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiErrorLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.9998 89.3333H67.0444M66.9998 44.6667V72.5833M18.0339 44.1809L44.1639 18.0342C45.0014 17.1967 46.1181 16.75 47.3464 16.75H86.7089C87.8814 16.75 89.0539 17.1967 89.8914 18.0342L115.966 44.1251C116.803 44.9626 117.25 46.0792 117.25 47.3076V86.6924C117.25 87.8649 116.803 89.0374 115.966 89.8749L89.8914 115.966C89.0539 116.803 87.9373 117.25 86.7089 117.25H47.2906C46.7017 117.256 46.1173 117.146 45.5711 116.926C45.0249 116.705 44.5277 116.379 44.1081 115.966L18.0339 89.8749C17.6206 89.4553 17.2944 88.9581 17.074 88.4119C16.8536 87.8657 16.7434 87.2814 16.7498 86.6924V47.3076C16.7498 46.1351 17.1964 44.9626 18.0339 44.1251V44.1809Z",
    stroke: "#8E8E8E",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiErrorLine);
export default __webpack_public_path__ + "static/media/si_error-line.9e55a861081d65a11fae64432897f43c.svg";
export { ForwardRef as ReactComponent };